export default "__VITE_ASSET__D5yc3jEj__"